import React, { Component } from 'react';
import { Helmet } from 'react-helmet';
import { Link } from 'react-router-dom';

// Components
import Header from '../components/Global/Header';
import FormContainer from '../components/Global/FormContainer';

class PageNotFound extends Component {

  render() {
    const { appName, path } = this.props;

    return (
      <div className="page-not-found">
        <Helmet>
          <title>Page Not Found | {appName}</title>
        </Helmet>
        <Header path={path}/>
        <FormContainer>
          <header>
            <h2>We can't seem to find the page you're looking for.</h2>
          </header>
          <div>
            <p>
              Sorry, the page you were looking for doesn’t exist.
              <br/>
              Try going to <Link to="/" className="text-link">LockerLinked.com</Link>
            </p>
          </div>
        </FormContainer>
      </div>
    );
  }
}

export default PageNotFound


// WEBPACK FOOTER //
// ./src/screens/PageNotFound.js